export default __webpack_public_path__ + "static/media/55.57be1537.png";